import ImageProvider from './hooks/useImage';

import { ImageProps } from './@types/ImageProps';
import ImageElement from './handles/ImageElement';

const Image = (props: ImageProps) => {
	return (
		<ImageProvider {...props}>
			<ImageElement />
		</ImageProvider>
	);
};

export default Image;
